import React from 'react';
import { Box } from '@mui/material';
import { cardSx } from './uiHelpers';

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  unit?: React.ReactNode;
  note?: React.ReactNode;
  icon?: React.ReactNode;
  // 'compact' is the smaller meta tile used on contest headers.
  variant?: 'default' | 'compact';
}

export const StatTile = ({ label, value, unit, note, icon, variant = 'default' }: StatTileProps) => {
  if (variant === 'compact') {
    return (
      <Box sx={{ ...cardSx, boxShadow: 'none', p: '14px 16px', display: 'flex', flexDirection: 'column', gap: 0.75, minWidth: 0 }}>
        <Box sx={{ fontSize: 12, color: 'var(--muted)', display: 'flex', gap: 0.75, alignItems: 'center', '& svg': { fontSize: 14 } }}>
          {icon}
          {label}
        </Box>
        <Box sx={{ fontSize: 15, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</Box>
      </Box>
    );
  }
  return (
    <Box sx={{ ...cardSx, p: 2, display: 'flex', flexDirection: 'column', gap: 1.25, minWidth: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13, color: 'var(--muted)', fontWeight: 500, '& svg': { fontSize: 16 } }}>
        {label}
        {icon}
      </Box>
      <Box sx={{ fontSize: 26, fontWeight: 600, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', lineHeight: 1.15 }}>
        {value}
        {unit && <Box component="span" sx={{ fontSize: 14, fontWeight: 500, color: 'var(--muted)', ml: 0.5 }}>{unit}</Box>}
      </Box>
      {note && <Box sx={{ fontSize: 12, color: 'var(--muted)' }}>{note}</Box>}
    </Box>
  );
};

// Four tiles across on wide containers, two on narrow ones.
export const StatGrid = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' } }}>
    {children}
  </Box>
);
